import { fromPostgrest, guard, raise, type Result } from '@/lib/result';
import { supabase } from '@/lib/supabase';

import { mapAppSetting, type AppSetting } from '../model/app-setting';

export const configRepository = {
  async getSettings(): Promise<Result<readonly AppSetting[]>> {
    return guard(async () => {
      const { data, error } = await supabase
        .from('app_settings')
        .select('key, value, kind, updated_at');
      if (error) throw fromPostgrest(error);
      return ((data ?? []) as unknown[]).map(mapAppSetting);
    });
  },

  /** Admin-only write, enforced server-side by the set_app_setting() SECURITY
   * DEFINER RPC (checks profiles.is_admin, rejects unknown keys). */
  async setSetting(key: string, value: unknown): Promise<Result<void>> {
    return guard(async () => {
      const { error } = await supabase.rpc('set_app_setting', {
        p_key: key,
        p_value: value,
      });
      if (error) raise('server', error.message, error);
    });
  },

  /** Subscribe to any app_settings change via Realtime. Returns unsubscribe. */
  subscribe(onChange: () => void): () => void {
    const channel = supabase
      .channel('app_settings')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'app_settings' }, () =>
        onChange(),
      )
      .subscribe();
    return () => {
      void supabase.removeChannel(channel);
    };
  },
};
